module.exports = __webpack_public_path__ + "img/sign.994ac0ae.svg";